import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// FAQ with FAQPage JSON-LD. `items` = [{q, a}].
export default function Faq({ items, title = "Frequently asked questions", withSchema = true }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };
  return (
    <div data-testid="faq-section">
      {withSchema && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
      {title && <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-forest-950 mb-8">{title}</h2>}
      <Accordion type="single" collapsible className="space-y-3">
        {items.map((it, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="border border-forest/10 rounded-2xl px-5 bg-card data-[state=open]:border-terracotta/30 transition-colors"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="text-left font-serif text-lg font-semibold text-forest-950 hover:no-underline py-5">
              {it.q}
            </AccordionTrigger>
            <AccordionContent className="text-forest-950/75 leading-relaxed pb-5 text-[15px]">
              {it.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
